<kt-base-modal [title]="'Handover Notes'" [showFooter]="true">
    <div modal-body>
        <kt-loader [showLoader]="loading()">
            <ul class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-2x nav-tabs-line-brand" role="tablist">
                <li class="nav-item cursor-pointer">
                    <a class="nav-link {{activeTab === tabs[0] ? 'active' : ''}}"
                        (click)="changeTab(tabs[0])"> Active </a>
                </li>
                <li class="nav-item cursor-pointer">
                    <a class="nav-link {{activeTab === tabs[1] ? 'active' : ''}}"
                        (click)="changeTab(tabs[1])">Completed / Expired</a>
                </li>
                <li class="ms-auto">
                    <button type="button" (click)="refreshHandler()" class="btn btn-label-brand btn-sm btn-icon ms-2"
                        ngbTooltip="Refresh" container="body">
                        <svg-icon class="refresh_news-feed_svg svg_icon13x13" src="assets/media/iq-svg/without_circle/icon_set_3/refresh.svg"></svg-icon>
                    </button>
                </li>
                <li>
                    <div ngbDropdown [placement]="'bottom-right'">
                        <a ngbDropdownToggle href="javascript:;"
                            class="btn btn-label-brand btn-sm dropdown-toggle ms-2">
                            Order By
                            <!-- {{this.currentOrderBy}} -->
                        </a>
                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit">
                            <ul class="kt-nav">
                                <li class="kt-nav__item dropdown-item"
                                    (click)="orderByHandler(orderByType.Created_Date)">
                                    <a href="javascript:;" class="kt-nav__link">
                                        <span class="kt-nav__link-text  width-max-content">Created Date</span>
                                    </a>
                                </li>
                                <li class="kt-nav__item dropdown-item"
                                    (click)="orderByHandler(orderByType.Modified_Date)">
                                    <a href="javascript:;" class="kt-nav__link">
                                        <span class="kt-nav__link-text  width-max-content">Modified Date</span>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <button *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_MANAGE" type="button"
                        class="btn btn-sm btn-brand ms-2" (click)="addClickHandler()">Add Handover
                        Note</button>
                </li>
            </ul>
            <!-- <div>
                    <kt-handover-notes-list [activeTab]="activeTab" [_shiftDetail]="shiftDetail"
                      [sort]="sort" [_lastPayload]="lastPayload" [totalCount]="totalCount"
                        (callback)="getAllHandoverNotes($event)">
                    </kt-handover-notes-list>
                </div> -->

            <div class="">
                <div class="tab-content h-100">
                    <div class="tab-pane {{activeTab === tabs[0] ? 'active' : ''}}">
                        <div>
                            <kt-handover-notes-list [_userId]="employee_user_id" [activeTab]="'Active'" [_sort]="sortingPayload"
                                [tabChanged]="activeTab === tabs[0]" [_shiftDetail]="shiftDetail">
                            </kt-handover-notes-list>
                        </div>
                    </div>
                    <div class="tab-pane {{activeTab === tabs[1] ? 'active' : ''}}">
                        <div>
                            <kt-handover-notes-list [_userId]="employee_user_id" [activeTab]="'Completed'" [_sort]="sortingPayload"
                                [tabChanged]="activeTab === tabs[1]" [_shiftDetail]="shiftDetail">
                            </kt-handover-notes-list>
                        </div>
                    </div>
                </div>
            </div>
        </kt-loader>
    </div>
    <div modal-footer>
        <button class="btn btn-brand" (click)="activeModal.close()">Close</button>
    </div>
</kt-base-modal>
